import React from 'react';
import LetterBlock from 'components/UI/LetterBlock/LetterBlock';
import './SoundTypes.module.scss';

export default function ShortSounds() {
    return (
        <div styleName="row">
            <LetterBlock letter="a" soundType="short-sound" />
            <LetterBlock letter="e" soundType="short-sound" />
            <LetterBlock letter="i" soundType="short-sound" />
            <LetterBlock letter="o" soundType="short-sound" />
            <LetterBlock letter="u" soundType="short-sound" />
        </div>
    );
}
